import _ from 'lodash';

class AuthInfoMgmt {
  constructor({ persistent = true, name }) {
    this._persistent = persistent;
    if (persistent) {
      this._storageItemName = `ICEQERP_${name}_AUTH_INFO`;
    }
    this._authInfo = {};
  }

  load() {
    try {
      this._authInfo = JSON.parse(window.localStorage.getItem(this._storageItemName)) || {};
    } catch (e) {
    }
  }

  changeAuthInfo(args) {
    _.assign(this._authInfo, args);
  }

  getCertificate() {
    return this._authInfo && this._authInfo.certificate;
  }

  getAuthInfo() {
    return this._authInfo;
  }

  isSignedIn() {
    return !!this.getCertificate();
  }

  signIn(args) {
    _.assign(this._authInfo, args);
    this._persistent && window.localStorage.setItem(this._storageItemName, JSON.stringify(this._authInfo));
  }

  signOut() {
    this._authInfo = {};
    this._persistent && window.localStorage.removeItem(this._storageItemName);
  }
}

export default AuthInfoMgmt;